var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRecruitLeftarrowWIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.668,
    height: 11.602,
    viewBox: "0 0 6.668 11.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mobile_recruit_leftarrow_w_icon",
    d: "M5651.527,10587.6a.864.864,0,0,1-.614-.255l-4.933-4.933a.868.868,0,0,1,0-1.228l4.933-4.933a.867.867,0,0,1,1.227,1.227l-4.32,4.32,4.32,4.32a.868.868,0,0,1-.613,1.48Z",
    transform: "translate(-5645.727 -10576)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRecruitLeftarrowWIcon);
export default __webpack_public_path__ + "static/media/mobile_recruit_leftarrow_w_icon.f88246d43097db9fe0c3a80f28be43e6.svg";
export { ForwardRef as ReactComponent };